import { takeLatest, call, put, select } from 'redux-saga/effects';
import ActionTypes from './constants';
import {
  customerSupportListSuccess,
  setCustomerSupportLoader,
  setCustomerSupportDetail,
  getTicketTypesList,
} from './actions';
import { openSnackBar } from '../Root/actions';
import request from '../../shared/lib/request';
import { selectCustomerSupport } from './selectors';
import { AnyAction } from 'redux';

export function* fetchTicketTypesListWorker() {
  try {
    yield put(setCustomerSupportLoader(true));
    const state: any = yield select(selectCustomerSupport);
    let sortBy = state.sortBy;
    if (sortBy === "") {
      sortBy = "updatedAt=desc";
    }
    const splitResult = sortBy.split("=");
    const url = `/admin/v1/get-ticket-types?sortBy=${splitResult[0]}&sortOrder=${splitResult[1]}`;
    
    const { result }: any = yield call(() => request({
      url,
      method: 'GET',
    }));
    
    yield put(customerSupportListSuccess(result));
    yield put(setCustomerSupportLoader(false));
  } catch (error) {
    yield put(setCustomerSupportLoader(false));
    yield put(openSnackBar('Error in fetching data'));
  }
}

export function* fetchTicketTypesByIdWorker(action: AnyAction) {
  try {
    yield put(setCustomerSupportLoader(true));
    const id = action.payload;
    const url = `/admin/v1/get-ticket-types`;
    const { result }: any = yield call(() => request({
      url,
      method: 'GET',
      params: { id },
    }));
    
    if (result && result.length) {
      let ticketTypeData = result.filter((item: any) => item.id === id);
      if (ticketTypeData.length > 0) {
        yield put(setCustomerSupportDetail(ticketTypeData[0]));
      }
    }
    yield put(setCustomerSupportLoader(false));
  } catch (error) {
    yield put(setCustomerSupportLoader(false));
    yield put(openSnackBar('Error in fetching data'));
  }
}

export function* editSaveCustomerSupportWorker(action: AnyAction) {
  try {
    yield put(setCustomerSupportLoader(true));
    const { id, title, type, isVisible, isPublished, imageUrl, isAdd } = action.payload;
    
    if (isAdd) {
      const url = `/admin/v1/create-ticket-type`;
      yield call(() => request({
        url,
        method: 'POST',
        data: { title, type, isVisible, isPublished, imageUrl },
      }));
      yield put(getTicketTypesList());
    } else {
      const url = `/admin/v1/edit-ticket-type`;
      yield call(() => request({
        url,
        method: 'PUT',
        data: { id, title, type, isVisible, isPublished, imageUrl },
      }));
      yield put(getTicketTypesList());
    }
    yield put(openSnackBar('Success'));
  } catch (error: any) {
    yield put(setCustomerSupportLoader(false));
    yield put(openSnackBar((error && error.data && (error.data.error || error.data.message)) || 'Error saving data'));
  }
}

export default function* customerSupportSaga() {
  yield takeLatest(ActionTypes.GET_TICKET_TYPES_LIST, fetchTicketTypesListWorker);
  yield takeLatest(ActionTypes.FETCH_TICKET_TYPES_BY_ID, fetchTicketTypesByIdWorker);
  yield takeLatest(ActionTypes.EDIT_SAVE_CUSTOMER_SUPPORT, editSaveCustomerSupportWorker);
}
